import { c as _c } from "react/compiler-runtime";
import { LazyVideo } from "@/components/ui/lazy-video";
export default function SportsSection() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LazyVideo src="/videos/sports-section.mp4" poster="/videos/sports-section-poster.webp" posterAlt={"An\xE1lisis deportivo con IA - Vista previa"} className="absolute inset-0 w-full h-full" videoClassName="object-cover object-[32%_100%]" />;
    t1 = <div className="absolute inset-0 bg-foreground/30" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative w-full flex flex-col"><div className="relative min-h-[70vh] sm:min-h-[80vh] lg:min-h-screen w-full">{t0}{t1}<div className="relative z-10 p-6 sm:p-12 lg:p-20 flex flex-col justify-start"><div className="max-w-md bg-background/70 backdrop-blur-md p-6 sm:p-8 border border-border/50 shadow-xl"><div className="flex items-center gap-2 mb-2"><p className="text-xs font-mono text-muted-foreground">SPT-4RP</p><div className="h-px flex-1 max-w-24 bg-border" /></div><h2 className="text-3xl sm:text-4xl md:text-5xl font-sans font-bold text-foreground mb-4">DEPORTES</h2><p className="text-sm font-mono text-muted leading-relaxed">Análisis de rendimiento en tiempo real para equipos y atletas profesionales. Nuestra plataforma procesa datos biométricos, tácticos y estratégicos para optimizar decisiones críticas durante competencias.</p></div></div></div><div className="h-16 sm:h-20 lg:h-24 bg-background" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}